angular.
module("dx.webapp.student").
constant("DX_ACCESSIBILITY_FILTER_SETTINGS",
	Object.freeze({
		SPELL_CHECK: 1,
		TEXT_TO_SPEECH: 2,
		EXTENDED_TIME: 4,
		AUDIO_FILES: 8,
		IMMERSIVE_READER: 16,
	})
);
